import { useRef } from 'react';
import Input from '../../UI/Input'
import classes from './MealitemForm.module.css'

const MealitemForm  = props=>{
    const amountInputRef = useRef();
    const submitHandler = event=>{
        event.preventDefault();
        const enteredAmount = amountInputRef.current.value;
        const enteredAmountNumber = +enteredAmount;

        if(enteredAmount.trim().length===0 || enteredAmountNumber<1){
                return ;
        }
        props.onAddToCart(enteredAmountNumber);
        
    };
    return (
        <form className={classes.form} onSubmit={submitHandler}>
            <Input 
            ref= {amountInputRef}
            label = "Amount" input = {{
                id: 'amount_' + props.id, // this changed!
                type:"number",
                min:'1',
                max:"5",
                step:'1',
                defaultValue:'1'
            }}/>
            <button>+Add</button>
        </form>
    )
}

export default MealitemForm